'use client';

import { IconBrandX } from '@tabler/icons-react';
import { useTranslations } from 'next-intl';
import { canonicalXPostUrl } from '@/lib/media-source';

export default function XSourceLink({ url, className = '' }) {
  const t = useTranslations('GateD');
  const href = canonicalXPostUrl(url);
  if (!href) return null;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      title={t('common.viewOriginalPost')}
      aria-label={t('common.viewOriginalPost')}
      onClick={(event) => event.stopPropagation()}
      onKeyDown={(event) => event.stopPropagation()}
      className={`inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-white/15 bg-black/45 text-white backdrop-blur-sm transition hover:scale-105 hover:bg-black/70 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white ${className}`}
    >
      <IconBrandX size={16} aria-hidden="true" />
    </a>
  );
}
